import React from 'react';
import Skeleton from 'react-loading-skeleton';
import Classnames from 'classnames';

import './skeleton-loader-list-item.scss';

interface SkeletonLoaderListItemProps {
    height?: number;
    count?: number;
    hasBorderWrapper?: boolean;
}

export const SkeletonLoaderListItem: React.FC<SkeletonLoaderListItemProps> = ({
    height = 44,
    count = 5,
    hasBorderWrapper,
}): React.ReactElement => {
    const classes = Classnames('skeleton-loader-list-item', {
        'skeleton-loader-list-item--has-border-wrapper': hasBorderWrapper,
    });

    return <Skeleton containerClassName={classes} height={height} count={count} inline={true} />;
};
